import { IOrganisation } from "@/types/index";

export class Organisation {
  private _data!: IOrganisation;
  constructor(data: IOrganisation | Organisation) {
    if (data instanceof Organisation) {
      return data;
    }
    this._data = data;
  }

  get name(): string {
    return this._data?.name || "";
  }

  get applicationName() {
    return this._data?.applicationName || "";
  }

  get userLimit(): number {
    return this._data?.userLimit || 0;
  }

  get settings() {
    return this._data;
  }

  get data(): IOrganisation {
    return this._data;
  }
  set data(val: IOrganisation) {
    this._data = val;
  }
}
